import React from 'react';
import styles from '../../styles/organisms/voteSection.module.scss';
import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';
import FantasyApartment from 'assets/images/FantasyApartment.png';
import PwanSmall from 'assets/images/p-wan-small.png';

interface VoteSectionProps {
  onVoteClick: () => void;
}

const VoteSection: React.FC<VoteSectionProps> = ({ onVoteClick }) => {
  return (
    <div className={styles.voteSection}>
      <div className={styles.voteSection__container}>
        <div className={styles.voteSection__pwanWrapper}>
          <img
            src={PwanSmall}
            alt="P-wan"
            className={styles.voteSection__pwan}
          />
        </div>

        {/* スマホ用タイトル */}
        <h2 className={`${styles.voteSection__title} ${styles.voteSection__titleSp}`}>
          妄想マンション投票
          <span className={styles.voteSection__round}>
            第<span className={styles.voteSection__roundNumber}>2</span>弾
          </span>
        </h2>

        <div className={styles.voteSection__character}>
          <img src={FantasyApartment} alt="P-manキャラクター" />
        </div>

        <div className={styles.voteSection__content}>
          {/* PC用タイトル */}
          <h2 className={`${styles.voteSection__title} ${styles.voteSection__titlePc}`}>
            妄想マンション投票
            <span className={styles.voteSection__round}>
              第<span className={styles.voteSection__roundNumber}>2</span>弾
            </span>
          </h2>

          <button
            className={styles.voteSection__button}
            onClick={onVoteClick}
          >
            <span>投票する</span>
            <GreenCircleArrow className={styles.voteSection__buttonIcon} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default VoteSection;